import React, {FC} from 'react';
import styled from 'styled-components';

import {BoxedInput} from '../../../../libs/shared/ui/src/components/boxedInputs/boxedInput';
import {
  BoxedInputElement,
  BoxedInputElementTypesEnum,
} from '../../../../libs/shared/ui/src/components/boxedInputs/boxedInputElement';
import {BoxedInputIcon} from '../../../../libs/shared/ui/src/components/boxedInputs/boxedInputIcon';
import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {fontSizes} from '../../../../libs/shared/ui/src/styles/fontStyles';

/*
 * Props.
 */

interface CommandPaletteSearchInputProps {
  value: string;
  onChange: (arg: string) => void;
  placeholder: string;
}

/*
 * Component.
 */

const CommandPaletteSearchInputComponent: FC<CommandPaletteSearchInputProps & {className?: string}> = (
  props,
) => (
  <BoxedInput size={VisualSizesEnum.LARGE} shouldAutoFocus boxClassName={props.className}>
    {(childProps) => (
      <>
        <BoxedInputIcon {...childProps} iconName="searchSmall" />
        <BoxedInputElement
          {...childProps}
          placeholder={props.placeholder}
          value={props.value}
          onChange={props.onChange}
          type={BoxedInputElementTypesEnum.TEXT}
        />
      </>
    )}
  </BoxedInput>
);

const StyledPaletteSearchInput = styled(CommandPaletteSearchInputComponent)`
  border-radius: 8px;
  margin: 0;

  input {
    margin-left: 1px;
    font-size: ${fontSizes.medium};
  }

  > div:first-child {
    margin-left: 5px;
  }

  svg {
    color: ${(p) => p.theme.greys.shade70};
  }
`;

export const CommandPaletteSearchInput: FC<CommandPaletteSearchInputProps> = (props) => (
  <StyledPaletteSearchInput {...props} />
);
